<template>
    <v-list-item
        :to="link"
        :title="label"
        :active="isActiveLink"
    >
        <template v-slot:prepend>
            <v-icon :icon="`mdi-${icon}`"/>
        </template>
        <template v-slot:append>
            <span
                v-if="restriction && restriction.includes && restriction.includes('dev')
                "
                class="dev-label"
            >DEV</span>
        </template>
    </v-list-item>
</template>

<script>
export default {
    name: "AppNavigationItem",

    props: {
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        link: {
            type: String,
            required: true,
        },
        restriction: {
            type: Array,
            required: false,
        },
    },
    computed: {
        isActiveLink() {
            const splitedArray = window.location.pathname.split("/")
            const mainPath = splitedArray.length > 1 ? `/${splitedArray[1]}` : this.$router.currentRoute.value.path

            if (this.$router.currentRoute.value.path === "/" && this.link === "/") {
                return true
            } else if (mainPath.includes(this.link) && this.link !== "/") {
                return true
            } else return false
        }
    }
};
</script>

<style lang="scss" scoped>
.v-theme--light {

    .v-list__tile__title,
    .v-icon {
        color: #94979b;
    }

    &.v-list-item--active {
        .v-icon {
            color: $white;
        }
    }
}

.dev-label {
    border: 1px solid #94979b;
    font-size: 10px;
    border-radius: 4px;
    padding: 2px 4px;
    margin-left: 6px;
    position: relative;
    bottom: 2px;
}
</style>
